export const initialGeneralExpenseForm = {
  expenseType: "",
  amount: "",
  description: "",
  expenseDate: "",
};

export const normalizeGeneralExpenses = (data) => {
  if (Array.isArray(data)) return data;
  return data?.generalExpenses || data?.expenses || data?.items || [];
};

export const filterGeneralExpenses = (expenses, searchTerm) => {
  const term = searchTerm.trim().toLowerCase();
  if (!term) return expenses;

  return expenses.filter((expense) => {
    const expenseType = expense?.expenseType?.toLowerCase() || "";
    const description = expense?.description?.toLowerCase() || "";
    const amount = String(expense?.amount || "").toLowerCase();

    return expenseType.includes(term) || description.includes(term) || amount.includes(term);
  });
};

export const formatGeneralExpenseDate = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";

  return new Intl.DateTimeFormat("en-PK", {
    year: "numeric",
    month: "short",
    day: "2-digit",
  }).format(date);
};

export const formatGeneralExpenseAmount = (value) => {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return "-";

  return new Intl.NumberFormat("en-PK", {
    style: "currency",
    currency: "PKR",
    maximumFractionDigits: 0,
  }).format(amount);
};

export const mapGeneralExpenseToForm = (expense) => ({
  expenseType: expense?.expenseType || "",
  amount: expense?.amount !== undefined && expense?.amount !== null ? String(expense.amount) : "",
  description: expense?.description || "",
  expenseDate: expense?.expenseDate ? String(expense.expenseDate).slice(0, 10) : "",
});

export const validateGeneralExpenseForm = (form) => {
  const errors = {};

  if (!form.expenseType.trim()) {
    errors.expenseType = "Expense type is required.";
  }

  if (!form.amount || Number(form.amount) <= 0) {
    errors.amount = "Amount must be greater than 0.";
  }

  return errors;
};

export const buildGeneralExpensePayload = (form) => ({
  expenseType: form.expenseType.trim(),
  amount: Number(form.amount),
  description: form.description.trim(),
  expenseDate: form.expenseDate || null,
});
